import { render, staticRenderFns } from "./rationalDiet.vue?vue&type=template&id=5b52f2d8&scoped=true&"
import script from "./rationalDiet.vue?vue&type=script&lang=js&"
export * from "./rationalDiet.vue?vue&type=script&lang=js&"
import style0 from "./rationalDiet.vue?vue&type=style&index=0&id=5b52f2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52f2d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b52f2d8')) {
      api.createRecord('5b52f2d8', component.options)
    } else {
      api.reload('5b52f2d8', component.options)
    }
    module.hot.accept("./rationalDiet.vue?vue&type=template&id=5b52f2d8&scoped=true&", function () {
      api.rerender('5b52f2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/rationalDiet.vue"
export default component.exports